import { z } from 'zod';
export const HubResponseSchema = z.object({
    id: z.number().int().positive(),
    code: z.string().min(2).max(8),
    name: z.string(),
    city: z.string(),
    country: z.string().length(2),
    latitude: z.number().min(-90).max(90),
    longitude: z.number().min(-180).max(180),
    timezone: z.string(),
    hangarCapacity: z.number().int().nonnegative(),
});
export const CreateHubRequestSchema = HubResponseSchema.omit({ id: true });
export const UpdateHubRequestSchema = CreateHubRequestSchema.partial();
//# sourceMappingURL=hub.dto.js.map